module.exports = "<div id=\"geneticalgo\">\r\n  <div id=\"chart\"></div>\r\n  <!-- <div id=\"dataset-picker\"> -->\r\n</div>\r\n\r\n"